import React from 'react';
import ArrowComponent from './ArrowComponent';
import {Tag,InputNumber} from "antd";

const business_fields = {
		arrow:{
			rules:{
        type:"object"
			},
			props:{
				valuePropName:"value"
			},
			element:(field,options) => (
        <ArrowComponent 
					color="red"
					key={field} 
					onChange={options.onChange} 
					foreignLists={options.foreignLists}
					currentValues={options.currentValues}
					currentDisabled={options.currentDisabled}
				/>
			),
			view:(options,field) => (
				<ArrowComponent 
					color="red" 
					caption={true} 
					key={field} 
					view={true} 
					value={options} 
				/>
			)
		},
		"project-status":{
			rules:{
			},
			element:(field,options) => (<span>{options.value}</span>),
			view:(field) => (
				<Tag 
					color={
						field === "requested" ? "gray" : 
						(
							field === "assigned" ? "yellow" :
							(
								field === "inspected" ? "blue" : (field === "done" ? "green" : "orange")
							)
						) 
					}
				>
					{field.toUpperCase()}
				</Tag>
			)
		},
		"map_zoom":{
			rules:{
				type:"number"
			},
			element:(field,options) => (<InputNumber disabled={options.disabled} key={field}/>),	
			view:(field) => (
				<span>{field}</span>
			)
		}
};

export default business_fields;
